var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":"/images/promo/hero-section/spiral-calendar.png","alt":"Spiral calendar"}})}
var staticRenderFns = []

export { render, staticRenderFns }